import { render, staticRenderFns } from "./BarviewAccess.vue?vue&type=template&id=08930317&scoped=true&lang=html&"
import script from "./BarviewAccess.vue?vue&type=script&lang=js&"
export * from "./BarviewAccess.vue?vue&type=script&lang=js&"
import style0 from "./BarviewAccess.vue?vue&type=style&index=0&id=08930317&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08930317",
  null
  
)

export default component.exports